'use client';

import type { FC } from 'react';
import type { AnnouncementSurface } from './types';
import { useTopAnnouncement } from './use-top-announcement';

export const TopAnnouncementBar: FC<{
  className?: string;
  onlyId?: string;
  surface?: AnnouncementSurface;
}> = ({ className, onlyId, surface }) => {
  const { activeAnnouncement, closeAnnouncement } = useTopAnnouncement(onlyId, surface);

  if (!activeAnnouncement) return null;

  const Component = activeAnnouncement.component;
  return <Component className={className} onClose={() => closeAnnouncement(activeAnnouncement.id)} />;
};
